import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
  today,
} from "App/utils/helpers"
import React, { useEffect, useState } from "react"
import { deleteSepInternal } from "./api"
import { instance2, instanceVclaim } from "App/constants"
import { itSelfEmpty, removeZeroInFront } from "utils/all"
import { Loading, MasterButton } from "App/Component/ui"
import ModalDeleteConfirm from "App/Component/ui/Modal/ModalDeleteConfirm/ModalDeleteConfirm"
import { Paper, TableContainer } from "@material-ui/core"
import { getNamaRumahSakit } from "App/utils/cookies"
import { getDetailSepByNoSep, getSearchSEP } from "../../../utils"
import { getSep } from "pages/WsBridging/Sep/Sep/ui/helpers"
import { checkBackdateSEP, getProfilPasien } from "./helpers"
import fileDownload from "js-file-download"

function ListSEPInternal({ setOpenData, noSEP, formData }) {
  const [loadingData, setLoadingData] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)
  const [rowsSepInternal, setRowsSepInternal] = useState([])
  const initialStateInternalSEP = {
    nomor_sep: "",
    nomor_surat: "",
    tgl_rujukan_internal: "",
    kode_poli_tujuan: "",
  }
  const [loadingDeleteSep, setLoadingDeleteSep] = React.useState(false)
  const [showConfrimDelete, setShowConfrimDelete] = React.useState(false)
  const [dataSelected, setDataSelected] = React.useState(
    initialStateInternalSEP,
  )

  const setNewData = async () => {
    setLoadingData(true)
    try {
      const res = await instanceVclaim.post(
        "/api/v1/emr/bridging/sep/data-sep-internal",
        {
          nomor_sep: noSEP,
        },
      )
      if (res.status === 200) {
        setRowsSepInternal(itSelfEmpty(res.data?.response?.list, []))
        setLoadingData(false)
      } else {
        setLoadingData(false)
        defaultToastError(res.data?.metaData?.message)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleClickDelete = async () => {
    setLoadingDeleteSep(true)
    const res = await deleteSepInternal(dataSelected)
    if (res.state) {
      setNewData()
      defaultToastSuccess(res.message)
    } else {
      defaultToastError(res.message)
    }
    setShowConfrimDelete(false)
    setDataSelected(initialStateInternalSEP)
  }

  const handleSelectDelete = (row) => {
    setDataSelected({
      nomor_sep: row?.nosep,
      nomor_surat: row?.nosurat,
      tgl_rujukan_internal: row?.tglrujukinternal,
      kode_poli_tujuan: row?.kdpolituj,
    })
    setShowConfrimDelete(true)
  }

  const handleClickCetakSep = async (row) => {
    setLoadingDownload(true);
    let isBackDate = false;
    const resDetailSEP = getDetailSepByNoSep(row.nosep)
    const resNomorKartu = getSearchSEP({
      type: "1",
      nomor_kartu: formData.no_kartu,
      tgl_pelayanan: today(),
    })
    const resDataSEP = getSep(formData.no_sep)
    const resProfilPasien = getProfilPasien(
      removeZeroInFront(formData.patientID.toString()),
    );
    const resCheckBackDate = checkBackdateSEP(formData.id_registration);
  
    await Promise.all([
      resDataSEP,
      resDetailSEP,
      resProfilPasien,
      resNomorKartu,
      resCheckBackDate,
    ]).then(async (responses) => {
      const response1 = responses[0]
      const response2 = responses[1]
      const response3 = responses[2]
      const response4 = responses[3]
      const response5 = responses[4]
      if (
        response1.state &&
        response2.state &&
        response3.state &&
        response4.state
      ) {
        const EP1 = response1.data
        const EP2 = response2.data
        const EP3 = response3.data
        const dataResNoKartu = response4.data.peserta
        const rm = dataResNoKartu.mr.noMR
        const nama = formData.nama
        console.log("response5?.data", response5?.data)
        if(response5.state){
          if(!isNull(response5?.data?.length) && response5?.data?.length > 0){
            isBackDate = true
          }else{
            isBackDate = false
          }
        }else{
          isBackDate = false
        }
  
        const payload = {
          nama_rumah_sakit: getNamaRumahSakit(),
          no_sep: row.nosurat,
          tgl_sep: row.tglrujukinternal,
          no_kartu: EP1.peserta.noKartu,
          rm: rm,
          nama: nama,
          tgl_lahir: EP1.peserta.tglLahir,
          jenis_kelamin: EP1?.peserta?.kelamin == 'L' ? 'Laki-laki': EP1?.peserta?.kelamin == 'P' ? 'Perempuan' : '',
          no_tlp: EP3?.[0]?.mobile_phone_number??null,
          spesialis: row.nmtujuanrujuk,
          dokter: EP1.jnsPelayanan === 'Rawat Inap' ? EP1.kontrol.nmDokter : EP1.dpjp.nmDPJP,
          faskes_perujuk: EP2.provPerujuk.nmProviderPerujuk,
          diagnosa_awal: EP2.diagnosa,
          catatan: EP1.catatan,
          peserta:  EP1.peserta.jnsPeserta,
          jns_rawat: EP1.jnsPelayanan,
          jns_kunjungan: 'Rujuk Internal',
          poli_perujuk: "",
          kls_hak: EP1.peserta.hakKelas,
          kls_rawat: EP1.jnsPelayanan !== 'Rawat Inap' ? "" : EP1.kelasRawat,
          penjamin: EP1?.penjamin??" ",
          isBackDate: false,
          prosedur: EP1?.flagProcedure?.nama??"",
          prolanisPRB: dataResNoKartu?.informasi?.prolanisPRB || null,
        }
  
        const response = await instance2.post("/sep_regist/cetak-pdf", payload, {
          responseType: "blob",
        });
        fileDownload(response.data, `${rm}_${nama}.pdf`)
        setLoadingDownload(false);
      }else{
        defaultToastError('Gagal mengambil data !');
        setLoadingDownload(false);
      }
    })
  }

  useEffect(() => {
    setNewData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {showConfrimDelete && (
        <ModalDeleteConfirm
          setShowModalDeleteConfirm={setShowConfrimDelete}
          confirmHandle={handleClickDelete}
        />
      )}

      <Paper
        className="show-element"
        style={{
          padding: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "1rem",
            }}
          >
            Data SEP Internal
          </p>
          <button
            type="button"
            className="x-button"
            onClick={() => setOpenData(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="x-icon"
              fill="none"
              viewBox="0 0 20 20"
              stroke="#3d3d3d"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <TableContainer
          className="custom-scrollbar "
          style={{
            maxHeight: "400px",
          }}
        >
          {loadingData ? (
            <>
              <Loading show={true} />
            </>
          ) : (
            <>
              <DataListSEPInternal
                rows={rowsSepInternal}
                handleSelectDelete={handleSelectDelete}
                loadingDeleteSep={loadingDeleteSep}
                handleClickCetakSep={handleClickCetakSep}
                loadingDownload={loadingDownload}
              />
            </>
          )}
        </TableContainer>
      </Paper>
    </>
  )
}

const DataListSEPInternal = ({
  rows,
  handleSelectDelete,
  loadingDeleteSep,
  handleClickCetakSep,
  loadingDownload,
}) => {
  return (
    <>
      {!isNull(rows) && rows.length > 0 ? (
        rows.map((item, index) => {
          return (
            <>
              <CardDataSepInternal
                row={item}
                key={index}
                handleSelectDelete={handleSelectDelete}
                loadingDeleteSep={loadingDeleteSep}
                handleClickCetakSep={handleClickCetakSep}
                loadingDownload={loadingDownload}
              />
            </>
          )
        })
      ) : (
        <>
          <div style={{ textAlign: "center" }}>
            <p>Tidak Ada Data SEP Internal</p>
          </div>
        </>
      )}
    </>
  )
}

const CardDataSepInternal = ({ row, loadingDeleteSep, handleSelectDelete, handleClickCetakSep, loadingDownload }) => {
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff",
          padding: "1rem",
          borderRadius: 8,
          marginBottom: "0.5rem",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: "12px",
              fontWeight: "500",
              letterSpacing: "5",
            }}
          >
            No Surat : {row.nosurat}
          </p>
          <div style={{ display: "flex", justifyContent: "end", gap: 4 }}>
            <MasterButton
              type="button"
              disabled={loadingDeleteSep}
              color={loadingDeleteSep ? "secondary" : "danger"}
              name={loadingDeleteSep ? "Loading..." : "HAPUS"}
              onClick={() => handleSelectDelete(row)}
              size="md"
            />
            <MasterButton
             type="button"
              disabled={loadingDownload}
              color={loadingDownload ? "secondary" : "green"}
              name={loadingDownload ? "Loading..." : "PDF"}
              onClick={() => handleClickCetakSep(row)}
              size="md"
            />
          </div>
        </div>

        <table
          style={{
            width: "90%",
            marginTop: "0.2rem",
            fontSize: "10px",
          }}
        >
          <tbody>
            <tr>
              <td>Diagnosa</td>
              <td width="5%">:</td>
              <td>{`${row.diagppk} - ${row.nmdiag}`}</td>
            </tr>
            <tr>
              <td>fdate</td>
              <td width="5%">:</td>
              <td>{row.fdate}</td>
            </tr>
            <tr>
              <td>flaginternal</td>
              <td width="5%">:</td>
              <td>{row.flaginternal}</td>
            </tr>
            <tr>
              <td>flagprosedur</td>
              <td width="5%">:</td>
              <td>{row.flagprosedur}</td>
            </tr>
            <tr>
              <td>flagsep</td>
              <td width="5%">:</td>
              <td>{row.flagsep}</td>
            </tr>
            <tr>
              <td>fuser</td>
              <td width="5%">:</td>
              <td>{row.fuser}</td>
            </tr>
            <tr>
              <td>Dokter</td>
              <td width="5%">:</td>
              <td>{`${row.kddokter} - ${row.nmdokter}`}</td>
            </tr>
            <tr>
              <td>Penunjang</td>
              <td width="5%">:</td>
              <td>{`${row.kdpenunjang} - ${row.nmpenunjang}`}</td>
            </tr>
            <tr>
              <td>Poli Asal</td>
              <td width="5%">:</td>
              <td>{`${row.kdpoliasal} - ${row.nmpoliasal}`}</td>
            </tr>
            <tr>
              <td>Poli Tujuan</td>
              <td width="5%">:</td>
              <td>{`${row.kdpolituj} - ${row.nmtujuanrujuk}`}</td>
            </tr>
            <tr>
              <td>nokapst</td>
              <td width="5%">:</td>
              <td>{row.nokapst}</td>
            </tr>
            <tr>
              <td>No SEP</td>
              <td width="5%">:</td>
              <td>{row.nosep}</td>
            </tr>
            <tr>
              <td>No SEP Ref</td>
              <td width="5%">:</td>
              <td>{row.nosepref}</td>
            </tr>
            <tr>
              <td>opsikonsul</td>
              <td width="5%">:</td>
              <td>{row.opsikonsul}</td>
            </tr>
            <tr>
              <td>ppkpelsep</td>
              <td width="5%">:</td>
              <td>{row.ppkpelsep}</td>
            </tr>
            <tr>
              <td>tglrujukinternal</td>
              <td width="5%">:</td>
              <td>{row.tglrujukinternal}</td>
            </tr>
            <tr>
              <td>tglsep</td>
              <td width="5%">:</td>
              <td>{row.tglsep}</td>
            </tr>
            <tr>
              <td>tujuanrujuk</td>
              <td width="5%">:</td>
              <td>{row.tujuanrujuk}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

export default ListSEPInternal
